import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { byPassMaintenanceMode, changeSystemStatus } from './thunks';

export const systemDownSlice = createSlice({
  name: 'systemDown',
  initialState: {
    isByPassMaintenanceMode: false,
    systemStatus: {
      isSystemDown: false,
      restoreDate: '',
    },
  },
  reducers: {
    clear: (state) => {
      state.isByPassMaintenanceMode = false;

      state.systemStatus = {
        isSystemDown: false,
        restoreDate: '',
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      changeSystemStatus,
      (
        state,
        action: PayloadAction<{
          isSystemDown: boolean;
          restoreDate: string;
        }>,
      ) => {
        state.systemStatus = action.payload;
      },
    );
    builder.addCase(
      byPassMaintenanceMode,
      (state, action: PayloadAction<boolean>) => {
        state.isByPassMaintenanceMode = action.payload;
      },
    );
  },
});
